module.exports = __webpack_public_path__ + "img/tablete-c-sombra.67a46862.png";